import Swal from "sweetalert2";
import WAServices from '../../services/WAServices';

const waServices = new WAServices();

export const openCommentPopup = async (auth_token, chat_id, onSuccess, onError) => {
    
    try {
        // STEP 1: Fetch existing comment first
        const response = await waServices.getComment(auth_token, { chat_id });

        let comment = "";
        if (response?.data?.status === "success") {
            comment = response.data.data.comment || "";
        }

        // STEP 2: Now open popup with default value
        return Swal.fire({
            title: "Add comment",
            input: "textarea",
            inputValue: comment,   // <-- Correct way to set default value
            showCancelButton: true,
            confirmButtonText: "Send",
            showLoaderOnConfirm: true,

            preConfirm: async (message) => {
                if (!message) {
                    Swal.showValidationMessage("Message cannot be empty");
                    return false;
                }

                try {
                    const data = { chat_id, comment: message };
                    const res = await waServices.addComment(auth_token, data);

                    if (res?.data?.status === "success") {
                        onSuccess("Comment added successfully.");
                    } else {
                        onError("Something went wrong.");
                    }

                } catch (err) {
                    onError("Server or network error.");
                }
            },

            allowOutsideClick: () => !Swal.isLoading(),
        });

    } catch (error) {
        onError("Server or network error.");
    }
};